import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type SetMeetingNoteReviewedInput = {
  clientId: string;
  meetingNoteId: string;
  isReviewed: boolean;
};

export const useSetMeetingNoteReviewed = (eventId: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation<
    unknown,
    Error,
    SetMeetingNoteReviewedInput
  >({
    mutationFn: ({ clientId, meetingNoteId, isReviewed }) =>
      api.patch(`clients/${clientId}/meeting-notes/${meetingNoteId}/review`, { isReviewed }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar-events', eventId, 'meeting-notes'] });
    },
  });

  const setMeetingNoteReviewed = async (input: SetMeetingNoteReviewedInput): Promise<void> => {
    await mutateAsync(input);
  };

  return { setMeetingNoteReviewed, isLoading };
};
